import { Link } from "react-router-dom";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  moreLabel?: string;
  morePath?: string;
}

export default function SectionHeading({ eyebrow, title, subtitle, moreLabel, morePath }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="min-w-0">
        {eyebrow && (
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-700 uppercase mb-2">
            <span className="w-5 h-px bg-accent-500"></span>
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl md:text-2xl lg:text-[28px] font-bold text-foreground-950 leading-tight">
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {moreLabel && morePath && (
        <Link
          href={morePath}
          to={morePath}
          className="shrink-0 inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}